<template>
  <div class="chat">
    <div class="chat-head">
      <img src="@/assets/image/icon-chat.png" alt="" />
    </div>
    <div class="chat-content" ref="chatBox">
      <div
        v-for="(item, index) in chatList"
        :key="index"
        class="chat-content-box"
        :class="item.userID == UserId ? 'type1' : 'type2'"
      >
        <div class="box-name">
          {{ item.userName }}
          <span>{{ formatDate(item.sendTime) }}</span>
        </div>
        <div class="box-text">
          <div v-if="item.messageType == 1">
            {{ item.content }}
          </div>
          <div v-else>
            <img
              class="imageMessage"
              :src="`data:image/png;base64, ${parseContent(item.content)}`"
              @click="openImagePreview(item)"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showImagePreview"
      class="image-preview-overlay"
      @click.self="closeImagePreview"
    >
      <img :src="previewImageSrc" class="image-preview-large" />
      <button class="close-btn" @click="closeImagePreview">✕</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "observation-chat",
  data() {
    return {
      // 消息輸入框
      chatMessage: "",
      // 歷史消息列表
      chatList: [],
      showImagePreview: false,
      previewImageSrc: '',
    };
  },
  computed: {
    ...mapGetters(["liveChats", "LiveChatChannel", "UserId", "UserName"]),
  },
  watch: {
    chatList: {
      handler(newVal, oldVal) {
        this.handleScrollBottom();
      },
      deep: true,
    },
  },
  created() {
    this.retrieveChatsMessage();
    this.handleScrollBottom();
  },
  methods: {
    // 滚动到底部
    handleScrollBottom() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const scrollElem = this.$refs.chatBox;
          scrollElem.scrollTo({
            top: scrollElem.scrollHeight,
            behavior: "smooth",
          });
        });
      });
    },
    async retrieveChatsMessage() {
      this.$store.dispatch("retrieveChats", {
        ClassroomId: this.$store.state.classRoomId,
        MessageDisplayQty: 100,
      });
      await this.$axios
        .get(
          `/classroomlivechat/details?liveChatChannel=${this.LiveChatChannel}`
        )
        .then((response) => {
          this.chatList =
            response.data.payload.liveChat.length > 0
              ? response.data.payload.liveChat
              : [];
        });
    },
    parseContent(content) {
      if (!content) {
        return "No content";
      }
      try {
        const parsedContent = JSON.parse(content);
        return parsedContent.base64.replace(/"/g, "") || "No message";
      } catch (e) {
        console.error("Error parsing content:", e);
        return "Invalid content";
      }
    },
    addMessage(msg) {
      this.chatList.push(msg);
      this.handleScrollBottom();
    },
    formatDate(timestamp) {
      const date = new Date(Number(timestamp))
      return date.toDateString()
    },
    openImagePreview(item) {
      this.previewImageSrc = `data:image/png;base64, ${this.parseContent(item.content)}`;
      this.showImagePreview = true;
    },
    closeImagePreview() {
      this.showImagePreview = false;
      this.previewImageSrc = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.chat {
  margin-top: 12px;
  width: 100%;
  height: 320px;
  // height: calc((100% - 24px) / 3);
  // min-height: 260px;
  border-radius: 8px;
  border: 1px solid var(--unnamed, #e9e9ea);
  background: #fff;
  overflow: hidden;
  .chat-head {
    width: 100%;
    height: 40px;
    background: var(--unnamed, #647cb1);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .chat-content {
    padding: 12px;
    width: 100%;
    height: calc(100% - 40px);
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE10+ */
    &::-webkit-scrollbar {
      display: none; /* ChromeSafari */
    }
    .chat-content-box {
      margin-bottom: 10px;
      display: flex;
      flex-wrap: wrap;
      .box-name {
        margin-bottom: 6px;
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        color: #333;
        font-size: 16px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        span {
          margin-left: 6px;
          color: #bfbfbf;
          font-size: 10px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      .box-text {
        max-width: 100%;
        min-height: 49px;
        padding: 14px 16px;
        border-radius: 6px;
        color: #fff;
        font-size: 16px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .imageMessage {
        max-width: 100%;
        max-height: 100px;
        width: auto;
        height: auto;
      }
    }

    .type1 {
      justify-content: flex-end;
      .box-name {
        justify-content: flex-end;
      }
      .box-text {
        border-top-right-radius: 0;
        background: #333;
      }
    }
    .type2 {
      .box-text {
        border-top-left-radius: 0;
        background: #647cb1;
      }
    }
  }
}

.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.image-preview-large {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
}

.close-btn {
  position: fixed;
  top: 20px;
  right: 30px;
  font-size: 30px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}
</style>
